import { ChapterStatus } from "@repo/app-types/entities/trainingParticipant";
import {
  IconClock,
  IconLock,
  IconPlayerPlay,
  IconRosetteDiscountCheck,
  IconSparkles,
} from "@tabler/icons-react";
import type { ReactNode } from "react";

export const chapterStatusIcons: Record<ChapterStatus, ReactNode> = {
  [ChapterStatus.Unavailable]: (
    <IconLock className="size-5 text-gray-300 group-hover:text-gray-400" />
  ),
  [ChapterStatus.Pending]: (
    <IconPlayerPlay className="size-5 text-indigo-500" />
  ),
  [ChapterStatus.InProgress]: <IconClock className="size-5 text-indigo-500" />,
  [ChapterStatus.Submitted]: (
    <IconSparkles className="size-5 text-purple-500" />
  ),
  [ChapterStatus.Completed]: (
    <IconRosetteDiscountCheck className="size-5 text-lime-500" />
  ),
};

export const chapterStatusDescriptions: Record<ChapterStatus, string> = {
  [ChapterStatus.Unavailable]: "Not yet available",
  [ChapterStatus.Pending]: "Next up",
  [ChapterStatus.InProgress]: "In progress",
  [ChapterStatus.Submitted]: "Submitted",
  [ChapterStatus.Completed]: "Completed",
};
